<template>

	<div>

    <div class="redeemed" >
      <h2 :style="getStyle('h2')">This code has been redeemed</h2>
      <div v-if="code.qr_code">
        <img :src="code.qr_code" alt="voucher code" />
      </div>
      <span class="strikeout">{{uniquecode}}</span>
      <p :style="getStyle('p')" v-if="config.udf_expiry_date">Expiry date: {{new Date(config.udf_expiry_date.replace(/-/g, "/")).toLocaleDateString()}}</p>
      <p>Activated {{activationDate.time}} <br> {{activationDate.date}}</p>
      <p v-if="(config.contact_vouchers_amount - 1) > 0"><button v-on:click="$store.commit('SET_SCREEN','welcome')" target="_blank" class="button" :style="getStyle('button')">Show my next voucher</button></p>
    </div>

	</div>

</template>

<script>
export default {
  name: 'ActivateVoucher',
  props: {
    email: String
  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loaded(){
          return this.$store.getters.getAppLoaded;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },
  },
  created : function(){
    if(this.config.contact_vouchers_amount > 0) {
        let vouchers_amount = this.config.contact_vouchers_amount - 1;
        this.$store.commit("SET_VOUCHERS_AMOUNT",vouchers_amount);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
  font-size: 18px;
  font-weight: bold;
}
p{
  font-size: 14px;
}
h2, p {
  color: #0f0f0f;
}

</style>
